import { render, staticRenderFns } from "./ContactZh.vue?vue&type=template&id=dc4b3eb4"
import script from "./ContactZh.vue?vue&type=script&lang=js"
export * from "./ContactZh.vue?vue&type=script&lang=js"
import style0 from "./ContactZh.vue?vue&type=style&index=0&id=dc4b3eb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports